// extracted by mini-css-extract-plugin
module.exports = {"root":"SignInComponent_root__2NyOO","formRow":"SignInComponent_formRow__3tyzH","forgotLink":"SignInComponent_forgotLink__kEb5F"};